import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  AgendaAppointmentItemDataFragment,
  GetHasPatientAppointmentsInFutureDocument,
} from '../../types/api/graphql';

export function usePatientAppointmentsCheck(
  patientId: string | null | undefined
) {
  const {
    data: patientAppointmentsCheckData,
    loading: patientAppointmentChecksLoading,
  } = useCacheQuery(GetHasPatientAppointmentsInFutureDocument, {
    variables: {
      patientId: patientId ?? '',
    },
    skip: !patientId,
  });

  const data = useMemo(() => {
    const appointments = (
      patientAppointmentsCheckData?.patientAppointmentInFuture ?? []
    ).map(option => option as AgendaAppointmentItemDataFragment);

    if (appointments.length > 0) {
      return {
        appointments,
        hasAppointments: true,
      };
    }

    return {
      appointments: [],
      hasAppointments: false,
    };
  }, [patientAppointmentsCheckData?.patientAppointmentInFuture]);

  return {
    data,
    loading: patientAppointmentChecksLoading,
  };
}
